/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES Media List API
 * PR TIMESメディアリスト用 API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    CheckDuplicatedMediaListNameResponse,
    CheckDuplicatedMediaListNameResponseFromJSON,
    CheckDuplicatedMediaListNameResponseToJSON,
    CreateMediaListRequest,
    CreateMediaListRequestFromJSON,
    CreateMediaListRequestToJSON,
    CreateMediaListResponse,
    CreateMediaListResponseFromJSON,
    CreateMediaListResponseToJSON,
    DeletePrtimesMediaListsRequest,
    DeletePrtimesMediaListsRequestFromJSON,
    DeletePrtimesMediaListsRequestToJSON,
    GetAutoMediaListIdRelatedToPressReleaseResponse,
    GetAutoMediaListIdRelatedToPressReleaseResponseFromJSON,
    GetAutoMediaListIdRelatedToPressReleaseResponseToJSON,
    GetAutoMediaListMediaOutletCountByTypeRequest,
    GetAutoMediaListMediaOutletCountByTypeRequestFromJSON,
    GetAutoMediaListMediaOutletCountByTypeRequestToJSON,
    GetAutoMediaListMediaOutletCountByTypeResponse,
    GetAutoMediaListMediaOutletCountByTypeResponseFromJSON,
    GetAutoMediaListMediaOutletCountByTypeResponseToJSON,
    GetAutoMediaListMediaOutletsRequest,
    GetAutoMediaListMediaOutletsRequestFromJSON,
    GetAutoMediaListMediaOutletsRequestToJSON,
    GetAutoMediaListMediaOutletsResponse,
    GetAutoMediaListMediaOutletsResponseFromJSON,
    GetAutoMediaListMediaOutletsResponseToJSON,
    GetDefaultMediaListNameResponse,
    GetDefaultMediaListNameResponseFromJSON,
    GetDefaultMediaListNameResponseToJSON,
    GetMediaListResponse,
    GetMediaListResponseFromJSON,
    GetMediaListResponseToJSON,
    GetMediaListsResponse,
    GetMediaListsResponseFromJSON,
    GetMediaListsResponseToJSON,
    GetPrtimesMediaListsMediaOutletsRequest,
    GetPrtimesMediaListsMediaOutletsRequestFromJSON,
    GetPrtimesMediaListsMediaOutletsRequestToJSON,
    GetPrtimesMediaListsMediaOutletsResponse,
    GetPrtimesMediaListsMediaOutletsResponseFromJSON,
    GetPrtimesMediaListsMediaOutletsResponseToJSON,
    MediaCategoriesResponse,
    MediaCategoriesResponseFromJSON,
    MediaCategoriesResponseToJSON,
    MediaListApiResponse,
    MediaListApiResponseFromJSON,
    MediaListApiResponseToJSON,
    PrtimesMediaListBadRequestResponse,
    PrtimesMediaListBadRequestResponseFromJSON,
    PrtimesMediaListBadRequestResponseToJSON,
    PrtimesMediaListCheckConflictRequest,
    PrtimesMediaListCheckConflictRequestFromJSON,
    PrtimesMediaListCheckConflictRequestToJSON,
    PrtimesMediaListCheckConflictResponse,
    PrtimesMediaListCheckConflictResponseFromJSON,
    PrtimesMediaListCheckConflictResponseToJSON,
    PrtimesMediaListInternalServerErrorResponse,
    PrtimesMediaListInternalServerErrorResponseFromJSON,
    PrtimesMediaListInternalServerErrorResponseToJSON,
    PrtimesMediaListMediaOutletsDeleteRequest,
    PrtimesMediaListMediaOutletsDeleteRequestFromJSON,
    PrtimesMediaListMediaOutletsDeleteRequestToJSON,
    PrtimesMediaListMediaOutletsDeleteResponse,
    PrtimesMediaListMediaOutletsDeleteResponseFromJSON,
    PrtimesMediaListMediaOutletsDeleteResponseToJSON,
    PrtimesMediaListMediaOutletsOverwriteRequest,
    PrtimesMediaListMediaOutletsOverwriteRequestFromJSON,
    PrtimesMediaListMediaOutletsOverwriteRequestToJSON,
    PrtimesMediaListMediaOutletsSearchCountByMediaTypeRequest,
    PrtimesMediaListMediaOutletsSearchCountByMediaTypeRequestFromJSON,
    PrtimesMediaListMediaOutletsSearchCountByMediaTypeRequestToJSON,
    PrtimesMediaListMediaOutletsSearchCountByMediaTypeResponse,
    PrtimesMediaListMediaOutletsSearchCountByMediaTypeResponseFromJSON,
    PrtimesMediaListMediaOutletsSearchCountByMediaTypeResponseToJSON,
    PrtimesMediaListNotFoundResponse,
    PrtimesMediaListNotFoundResponseFromJSON,
    PrtimesMediaListNotFoundResponseToJSON,
    PrtimesMediaListOperationLogRecordRequest,
    PrtimesMediaListOperationLogRecordRequestFromJSON,
    PrtimesMediaListOperationLogRecordRequestToJSON,
    PrtimesMediaListUnauthorizedResponse,
    PrtimesMediaListUnauthorizedResponseFromJSON,
    PrtimesMediaListUnauthorizedResponseToJSON,
    PrtimesMediaListsJoinRequest,
    PrtimesMediaListsJoinRequestFromJSON,
    PrtimesMediaListsJoinRequestToJSON,
    PrtimesMediaListsJoinResponse,
    PrtimesMediaListsJoinResponseFromJSON,
    PrtimesMediaListsJoinResponseToJSON,
    PrtimesMediaListsMediaOutletsSearchRequest,
    PrtimesMediaListsMediaOutletsSearchRequestFromJSON,
    PrtimesMediaListsMediaOutletsSearchRequestToJSON,
    PrtimesMediaListsMediaOutletsSearchResponse,
    PrtimesMediaListsMediaOutletsSearchResponseFromJSON,
    PrtimesMediaListsMediaOutletsSearchResponseToJSON,
    PrtimesMediaListsNewMediaOutletsResponse,
    PrtimesMediaListsNewMediaOutletsResponseFromJSON,
    PrtimesMediaListsNewMediaOutletsResponseToJSON,
    PrtimesMediaListsSelectedMediaListsLogGetResponse,
    PrtimesMediaListsSelectedMediaListsLogGetResponseFromJSON,
    PrtimesMediaListsSelectedMediaListsLogGetResponseToJSON,
    PrtimesMediaListsSelectedMediaListsLogOnlyDatesGetResponse,
    PrtimesMediaListsSelectedMediaListsLogOnlyDatesGetResponseFromJSON,
    PrtimesMediaListsSelectedMediaListsLogOnlyDatesGetResponseToJSON,
    PrtimesMediaListsSelectedMediaListsLogRecordRequest,
    PrtimesMediaListsSelectedMediaListsLogRecordRequestFromJSON,
    PrtimesMediaListsSelectedMediaListsLogRecordRequestToJSON,
    PrtimesMediaListsSelectedMediaListsLogRecordResponse,
    PrtimesMediaListsSelectedMediaListsLogRecordResponseFromJSON,
    PrtimesMediaListsSelectedMediaListsLogRecordResponseToJSON,
    PrtimesMediaListsSelectedMediaListsLogSummariesGetResponse,
    PrtimesMediaListsSelectedMediaListsLogSummariesGetResponseFromJSON,
    PrtimesMediaListsSelectedMediaListsLogSummariesGetResponseToJSON,
    RestorePrtimesMediaListsRequest,
    RestorePrtimesMediaListsRequestFromJSON,
    RestorePrtimesMediaListsRequestToJSON,
    SearchSelectedMediaOutletsRequest,
    SearchSelectedMediaOutletsRequestFromJSON,
    SearchSelectedMediaOutletsRequestToJSON,
    SearchSelectedMediaOutletsResponse,
    SearchSelectedMediaOutletsResponseFromJSON,
    SearchSelectedMediaOutletsResponseToJSON,
    SelectedMediaListLogMediaCountByTypeGetResponse,
    SelectedMediaListLogMediaCountByTypeGetResponseFromJSON,
    SelectedMediaListLogMediaCountByTypeGetResponseToJSON,
    UpdateMediaListRequest,
    UpdateMediaListRequestFromJSON,
    UpdateMediaListRequestToJSON,
    UpdateMediaListResponse,
    UpdateMediaListResponseFromJSON,
    UpdateMediaListResponseToJSON,
} from '../models';

export interface CheckDuplicatedPrtimesMediaListNameRequest {
    mediaListName: string;
}

export interface CheckPrtimesMediaListConflictRequest {
    mediaListId: number;
    prtimesMediaListCheckConflictRequest?: PrtimesMediaListCheckConflictRequest;
}

export interface CopyPrtimesMediaListRequest {
    mediaListId: number;
}

export interface CreatePrtimesMediaListRequest {
    createMediaListRequest?: CreateMediaListRequest;
}

export interface DeleteMediaOutletsFromPrtimesMediaListRequest {
    mediaListId: number;
    prtimesMediaListMediaOutletsDeleteRequest?: PrtimesMediaListMediaOutletsDeleteRequest;
}

export interface DeletePrtimesMediaListsOperationRequest {
    deletePrtimesMediaListsRequest?: DeletePrtimesMediaListsRequest;
}

export interface DownloadPrtimesMediaListRequest {
    mediaListId: number;
}

export interface GetAutoMediaListIdRelatedToPressReleaseRequest {
    releaseId: number;
}

export interface GetAutoMediaListMediaOutletCountByTypeOperationRequest {
    getAutoMediaListMediaOutletCountByTypeRequest?: GetAutoMediaListMediaOutletCountByTypeRequest;
}

export interface GetAutoMediaListMediaOutletsOperationRequest {
    getAutoMediaListMediaOutletsRequest?: GetAutoMediaListMediaOutletsRequest;
}

export interface GetMediaOutletsSearchCountByMediaTypeRequest {
    prtimesMediaListMediaOutletsSearchCountByMediaTypeRequest?: PrtimesMediaListMediaOutletsSearchCountByMediaTypeRequest;
}

export interface GetPrtimesMediaListRequest {
    mediaListId: number;
}

export interface GetPrtimesMediaListsRequest {
    searchKeyword?: string;
    perPage?: number;
    page?: number;
    isExcludedMediaListWithoutMedia?: boolean;
    sortField?: GetPrtimesMediaListsSortFieldEnum;
    sortOrder?: GetPrtimesMediaListsSortOrderEnum;
}

export interface GetPrtimesMediaListsMediaOutletsOperationRequest {
    getPrtimesMediaListsMediaOutletsRequest?: GetPrtimesMediaListsMediaOutletsRequest;
}

export interface GetSelectedMediaListLogRequest {
    mediaListId: number;
    logId: number;
    page?: number;
    perPage?: number;
    dangerouslyFetchAllMediaOutlets?: boolean;
}

export interface GetSelectedMediaListLogMediaCountByTypeRequest {
    mediaListId: number;
    logId: number;
}

export interface GetSelectedMediaListLogOnlyDatesRequest {
    mediaListId: number;
    companyUserId?: number;
    isDeletedCompanyUsersOnly?: boolean;
}

export interface GetSelectedMediaListLogSummariesRequest {
    mediaListId: number;
    date: string;
    companyUserId?: number;
    isDeletedCompanyUsersOnly?: boolean;
}

export interface JoinPrtimesMediaListsRequest {
    prtimesMediaListsJoinRequest?: PrtimesMediaListsJoinRequest;
}

export interface OverwritePrtimesMediaOutletsRequest {
    mediaListId: number;
    prtimesMediaListMediaOutletsOverwriteRequest?: PrtimesMediaListMediaOutletsOverwriteRequest;
}

export interface RecordPrtimesMediaListOperationLogRequest {
    mediaListId: number;
    prtimesMediaListOperationLogRecordRequest?: PrtimesMediaListOperationLogRecordRequest;
}

export interface RecordSelectedMediaListLogRequest {
    mediaListId: number;
    prtimesMediaListsSelectedMediaListsLogRecordRequest?: PrtimesMediaListsSelectedMediaListsLogRecordRequest;
}

export interface RestorePrtimesMediaListsOperationRequest {
    restorePrtimesMediaListsRequest?: RestorePrtimesMediaListsRequest;
}

export interface SearchMediaOutletsRequest {
    prtimesMediaListsMediaOutletsSearchRequest?: PrtimesMediaListsMediaOutletsSearchRequest;
}

export interface SearchSelectedMediaOutletsOperationRequest {
    searchSelectedMediaOutletsRequest?: SearchSelectedMediaOutletsRequest;
}

export interface UpdatePrtimesMediaListRequest {
    mediaListId: number;
    updateMediaListRequest?: UpdateMediaListRequest;
}

/**
 * 
 */
export class PrtimesMediaListApi extends runtime.BaseAPI {

    /**
     * メディアリスト名が重複しているかどうか確認するAPI
     * メディアリスト名が重複しているかどうか確認するAPI
     */
    async checkDuplicatedPrtimesMediaListNameRaw(requestParameters: CheckDuplicatedPrtimesMediaListNameRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<CheckDuplicatedMediaListNameResponse>> {
        if (requestParameters.mediaListName === null || requestParameters.mediaListName === undefined) {
            throw new runtime.RequiredError('mediaListName','Required parameter requestParameters.mediaListName was null or undefined when calling checkDuplicatedPrtimesMediaListName.');
        }

        const queryParameters: any = {};

        if (requestParameters.mediaListName !== undefined) {
            queryParameters['media_list_name'] = requestParameters.mediaListName;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/prtimes_media_lists/check_duplicated_media_list_name`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CheckDuplicatedMediaListNameResponseFromJSON(jsonValue));
    }

    /**
     * メディアリスト名が重複しているかどうか確認するAPI
     * メディアリスト名が重複しているかどうか確認するAPI
     */
    async checkDuplicatedPrtimesMediaListName(requestParameters: CheckDuplicatedPrtimesMediaListNameRequest, initOverrides?: RequestInit): Promise<CheckDuplicatedMediaListNameResponse> {
        const response = await this.checkDuplicatedPrtimesMediaListNameRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * メディアリストで競合が起きているか確認するAPI
     * メディアリストで競合が起きているか確認するAPI
     */
    async checkPrtimesMediaListConflictRaw(requestParameters: CheckPrtimesMediaListConflictRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<PrtimesMediaListCheckConflictResponse>> {
        if (requestParameters.mediaListId === null || requestParameters.mediaListId === undefined) {
            throw new runtime.RequiredError('mediaListId','Required parameter requestParameters.mediaListId was null or undefined when calling checkPrtimesMediaListConflict.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/prtimes_media_lists/{media_list_id}/check_conflict`.replace(`{${"media_list_id"}}`, encodeURIComponent(String(requestParameters.mediaListId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PrtimesMediaListCheckConflictRequestToJSON(requestParameters.prtimesMediaListCheckConflictRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PrtimesMediaListCheckConflictResponseFromJSON(jsonValue));
    }

    /**
     * メディアリストで競合が起きているか確認するAPI
     * メディアリストで競合が起きているか確認するAPI
     */
    async checkPrtimesMediaListConflict(requestParameters: CheckPrtimesMediaListConflictRequest, initOverrides?: RequestInit): Promise<PrtimesMediaListCheckConflictResponse> {
        const response = await this.checkPrtimesMediaListConflictRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * メディアリストをコピーするAPI
     * メディアリストをコピーするAPI
     */
    async copyPrtimesMediaListRaw(requestParameters: CopyPrtimesMediaListRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<MediaListApiResponse>> {
        if (requestParameters.mediaListId === null || requestParameters.mediaListId === undefined) {
            throw new runtime.RequiredError('mediaListId','Required parameter requestParameters.mediaListId was null or undefined when calling copyPrtimesMediaList.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/prtimes_media_lists/{media_list_id}/copy`.replace(`{${"media_list_id"}}`, encodeURIComponent(String(requestParameters.mediaListId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MediaListApiResponseFromJSON(jsonValue));
    }

    /**
     * メディアリストをコピーするAPI
     * メディアリストをコピーするAPI
     */
    async copyPrtimesMediaList(requestParameters: CopyPrtimesMediaListRequest, initOverrides?: RequestInit): Promise<MediaListApiResponse> {
        const response = await this.copyPrtimesMediaListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * メディアリストを作成するAPI
     * メディアリストを作成するAPI
     */
    async createPrtimesMediaListRaw(requestParameters: CreatePrtimesMediaListRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<CreateMediaListResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/prtimes_media_lists`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateMediaListRequestToJSON(requestParameters.createMediaListRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateMediaListResponseFromJSON(jsonValue));
    }

    /**
     * メディアリストを作成するAPI
     * メディアリストを作成するAPI
     */
    async createPrtimesMediaList(requestParameters: CreatePrtimesMediaListRequest = {}, initOverrides?: RequestInit): Promise<CreateMediaListResponse> {
        const response = await this.createPrtimesMediaListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * メディアリストからメディアを削除
     * メディアリストからメディアを削除するAPI
     */
    async deleteMediaOutletsFromPrtimesMediaListRaw(requestParameters: DeleteMediaOutletsFromPrtimesMediaListRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<PrtimesMediaListMediaOutletsDeleteResponse>> {
        if (requestParameters.mediaListId === null || requestParameters.mediaListId === undefined) {
            throw new runtime.RequiredError('mediaListId','Required parameter requestParameters.mediaListId was null or undefined when calling deleteMediaOutletsFromPrtimesMediaList.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/prtimes_media_lists/{media_list_id}/media_outlets`.replace(`{${"media_list_id"}}`, encodeURIComponent(String(requestParameters.mediaListId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
            body: PrtimesMediaListMediaOutletsDeleteRequestToJSON(requestParameters.prtimesMediaListMediaOutletsDeleteRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PrtimesMediaListMediaOutletsDeleteResponseFromJSON(jsonValue));
    }

    /**
     * メディアリストからメディアを削除
     * メディアリストからメディアを削除するAPI
     */
    async deleteMediaOutletsFromPrtimesMediaList(requestParameters: DeleteMediaOutletsFromPrtimesMediaListRequest, initOverrides?: RequestInit): Promise<PrtimesMediaListMediaOutletsDeleteResponse> {
        const response = await this.deleteMediaOutletsFromPrtimesMediaListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * メディアリストを削除するAPI（複数削除に対応）
     * メディアリストを削除するAPI（複数削除に対応）
     */
    async deletePrtimesMediaListsRaw(requestParameters: DeletePrtimesMediaListsOperationRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<MediaListApiResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/prtimes_media_lists`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
            body: DeletePrtimesMediaListsRequestToJSON(requestParameters.deletePrtimesMediaListsRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MediaListApiResponseFromJSON(jsonValue));
    }

    /**
     * メディアリストを削除するAPI（複数削除に対応）
     * メディアリストを削除するAPI（複数削除に対応）
     */
    async deletePrtimesMediaLists(requestParameters: DeletePrtimesMediaListsOperationRequest = {}, initOverrides?: RequestInit): Promise<MediaListApiResponse> {
        const response = await this.deletePrtimesMediaListsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * メディアリストをダウンロードするAPI
     * メディアリストをダウンロードするAPI
     */
    async downloadPrtimesMediaListRaw(requestParameters: DownloadPrtimesMediaListRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<Blob>> {
        if (requestParameters.mediaListId === null || requestParameters.mediaListId === undefined) {
            throw new runtime.RequiredError('mediaListId','Required parameter requestParameters.mediaListId was null or undefined when calling downloadPrtimesMediaList.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/prtimes_media_lists/{media_list_id}/download`.replace(`{${"media_list_id"}}`, encodeURIComponent(String(requestParameters.mediaListId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     * メディアリストをダウンロードするAPI
     * メディアリストをダウンロードするAPI
     */
    async downloadPrtimesMediaList(requestParameters: DownloadPrtimesMediaListRequest, initOverrides?: RequestInit): Promise<Blob> {
        const response = await this.downloadPrtimesMediaListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * プレスリリースに紐付く自動選択リストのIDを取得するAPI（詳細はチケットを参照→ https://prtimes.atlassian.net/browse/MR-1161）。本当はpress_release/{release_id}/auto_media_list_idとしたいが、Featureを跨いでの開発がないため、一旦メディアリストとして定義しています。
     * プレスリリースに紐付く自動選択リストのIDを取得するAPI
     */
    async getAutoMediaListIdRelatedToPressReleaseRaw(requestParameters: GetAutoMediaListIdRelatedToPressReleaseRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<GetAutoMediaListIdRelatedToPressReleaseResponse>> {
        if (requestParameters.releaseId === null || requestParameters.releaseId === undefined) {
            throw new runtime.RequiredError('releaseId','Required parameter requestParameters.releaseId was null or undefined when calling getAutoMediaListIdRelatedToPressRelease.');
        }

        const queryParameters: any = {};

        if (requestParameters.releaseId !== undefined) {
            queryParameters['release_id'] = requestParameters.releaseId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/auto_media_lists/id_related_to_press_release`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetAutoMediaListIdRelatedToPressReleaseResponseFromJSON(jsonValue));
    }

    /**
     * プレスリリースに紐付く自動選択リストのIDを取得するAPI（詳細はチケットを参照→ https://prtimes.atlassian.net/browse/MR-1161）。本当はpress_release/{release_id}/auto_media_list_idとしたいが、Featureを跨いでの開発がないため、一旦メディアリストとして定義しています。
     * プレスリリースに紐付く自動選択リストのIDを取得するAPI
     */
    async getAutoMediaListIdRelatedToPressRelease(requestParameters: GetAutoMediaListIdRelatedToPressReleaseRequest, initOverrides?: RequestInit): Promise<GetAutoMediaListIdRelatedToPressReleaseResponse> {
        const response = await this.getAutoMediaListIdRelatedToPressReleaseRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 自動選択リストのメディア種別ごとのカウントを取得するAPI（検索キーワード、メディア種別、発行部数/PVでフィルターできる）
     * 自動選択リストのメディア種別ごとのカウントを取得するAPI（検索キーワード、メディア種別、発行部数/PVでフィルターできる）
     */
    async getAutoMediaListMediaOutletCountByTypeRaw(requestParameters: GetAutoMediaListMediaOutletCountByTypeOperationRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<GetAutoMediaListMediaOutletCountByTypeResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/auto_media_lists/media_outlet_count_by_type`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: GetAutoMediaListMediaOutletCountByTypeRequestToJSON(requestParameters.getAutoMediaListMediaOutletCountByTypeRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetAutoMediaListMediaOutletCountByTypeResponseFromJSON(jsonValue));
    }

    /**
     * 自動選択リストのメディア種別ごとのカウントを取得するAPI（検索キーワード、メディア種別、発行部数/PVでフィルターできる）
     * 自動選択リストのメディア種別ごとのカウントを取得するAPI（検索キーワード、メディア種別、発行部数/PVでフィルターできる）
     */
    async getAutoMediaListMediaOutletCountByType(requestParameters: GetAutoMediaListMediaOutletCountByTypeOperationRequest = {}, initOverrides?: RequestInit): Promise<GetAutoMediaListMediaOutletCountByTypeResponse> {
        const response = await this.getAutoMediaListMediaOutletCountByTypeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 自動選択リストのメディアを取得するAPI（検索キーワード、メディア種別、発行部数/PVでフィルターできる）
     * 自動選択リストのメディアを取得するAPI（検索キーワード、メディア種別、発行部数/PVでフィルターできる）
     */
    async getAutoMediaListMediaOutletsRaw(requestParameters: GetAutoMediaListMediaOutletsOperationRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<GetAutoMediaListMediaOutletsResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/auto_media_lists/media_outlets`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: GetAutoMediaListMediaOutletsRequestToJSON(requestParameters.getAutoMediaListMediaOutletsRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetAutoMediaListMediaOutletsResponseFromJSON(jsonValue));
    }

    /**
     * 自動選択リストのメディアを取得するAPI（検索キーワード、メディア種別、発行部数/PVでフィルターできる）
     * 自動選択リストのメディアを取得するAPI（検索キーワード、メディア種別、発行部数/PVでフィルターできる）
     */
    async getAutoMediaListMediaOutlets(requestParameters: GetAutoMediaListMediaOutletsOperationRequest = {}, initOverrides?: RequestInit): Promise<GetAutoMediaListMediaOutletsResponse> {
        const response = await this.getAutoMediaListMediaOutletsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * デフォルトのメディアリスト名を取得するAPI。新規作成画面に遷移したタイミングでメディアリスト名入力欄にデフォルト名を表示する時に使います。デフォルト名が被っていれば（1）、（2）のように後ろにつけます。
     * デフォルトのメディアリスト名を取得するAPI
     */
    async getDefaultPrtimesMediaListNameRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<GetDefaultMediaListNameResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/prtimes_media_lists/default_media_list_name`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetDefaultMediaListNameResponseFromJSON(jsonValue));
    }

    /**
     * デフォルトのメディアリスト名を取得するAPI。新規作成画面に遷移したタイミングでメディアリスト名入力欄にデフォルト名を表示する時に使います。デフォルト名が被っていれば（1）、（2）のように後ろにつけます。
     * デフォルトのメディアリスト名を取得するAPI
     */
    async getDefaultPrtimesMediaListName(initOverrides?: RequestInit): Promise<GetDefaultMediaListNameResponse> {
        const response = await this.getDefaultPrtimesMediaListNameRaw(initOverrides);
        return await response.value();
    }

    /**
     * 全てのカテゴリの取得
     * 全てのカテゴリを取得するAPI
     */
    async getMediaCategoriesRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<MediaCategoriesResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/prtimes_media_lists/media_categories`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MediaCategoriesResponseFromJSON(jsonValue));
    }

    /**
     * 全てのカテゴリの取得
     * 全てのカテゴリを取得するAPI
     */
    async getMediaCategories(initOverrides?: RequestInit): Promise<MediaCategoriesResponse> {
        const response = await this.getMediaCategoriesRaw(initOverrides);
        return await response.value();
    }

    /**
     * メディアを検索した結果のメディア種類ごとのカウントを取得する
     * メディアを検索した結果のメディア種類ごとのカウントを取得するAPI
     */
    async getMediaOutletsSearchCountByMediaTypeRaw(requestParameters: GetMediaOutletsSearchCountByMediaTypeRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<PrtimesMediaListMediaOutletsSearchCountByMediaTypeResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/prtimes_media_lists/media_outlets/search_count_by_media_type`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PrtimesMediaListMediaOutletsSearchCountByMediaTypeRequestToJSON(requestParameters.prtimesMediaListMediaOutletsSearchCountByMediaTypeRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PrtimesMediaListMediaOutletsSearchCountByMediaTypeResponseFromJSON(jsonValue));
    }

    /**
     * メディアを検索した結果のメディア種類ごとのカウントを取得する
     * メディアを検索した結果のメディア種類ごとのカウントを取得するAPI
     */
    async getMediaOutletsSearchCountByMediaType(requestParameters: GetMediaOutletsSearchCountByMediaTypeRequest = {}, initOverrides?: RequestInit): Promise<PrtimesMediaListMediaOutletsSearchCountByMediaTypeResponse> {
        const response = await this.getMediaOutletsSearchCountByMediaTypeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 新着メディアを取得するAPI。メディアリストの最終更新日以降に追加されたメディアについて取得します
     * 新着メディアを取得するAPI
     */
    async getNewMediaOutletNamesRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<PrtimesMediaListsNewMediaOutletsResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/prtimes_media_lists/new_media_outlets`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PrtimesMediaListsNewMediaOutletsResponseFromJSON(jsonValue));
    }

    /**
     * 新着メディアを取得するAPI。メディアリストの最終更新日以降に追加されたメディアについて取得します
     * 新着メディアを取得するAPI
     */
    async getNewMediaOutletNames(initOverrides?: RequestInit): Promise<PrtimesMediaListsNewMediaOutletsResponse> {
        const response = await this.getNewMediaOutletNamesRaw(initOverrides);
        return await response.value();
    }

    /**
     * PRTIMESリストの詳細を取得するためのAPI
     * PRTIMESリストの詳細を取得するためのAPI
     */
    async getPrtimesMediaListRaw(requestParameters: GetPrtimesMediaListRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<GetMediaListResponse>> {
        if (requestParameters.mediaListId === null || requestParameters.mediaListId === undefined) {
            throw new runtime.RequiredError('mediaListId','Required parameter requestParameters.mediaListId was null or undefined when calling getPrtimesMediaList.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/prtimes_media_lists/{media_list_id}`.replace(`{${"media_list_id"}}`, encodeURIComponent(String(requestParameters.mediaListId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetMediaListResponseFromJSON(jsonValue));
    }

    /**
     * PRTIMESリストの詳細を取得するためのAPI
     * PRTIMESリストの詳細を取得するためのAPI
     */
    async getPrtimesMediaList(requestParameters: GetPrtimesMediaListRequest, initOverrides?: RequestInit): Promise<GetMediaListResponse> {
        const response = await this.getPrtimesMediaListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * メディアリスト一覧を取得するAPI
     * メディアリスト一覧を取得するAPI
     */
    async getPrtimesMediaListsRaw(requestParameters: GetPrtimesMediaListsRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<GetMediaListsResponse>> {
        const queryParameters: any = {};

        if (requestParameters.searchKeyword !== undefined) {
            queryParameters['search_keyword'] = requestParameters.searchKeyword;
        }

        if (requestParameters.perPage !== undefined) {
            queryParameters['per_page'] = requestParameters.perPage;
        }

        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }

        if (requestParameters.isExcludedMediaListWithoutMedia !== undefined) {
            queryParameters['is_excluded_media_list_without_media'] = requestParameters.isExcludedMediaListWithoutMedia;
        }

        if (requestParameters.sortField !== undefined) {
            queryParameters['sort_field'] = requestParameters.sortField;
        }

        if (requestParameters.sortOrder !== undefined) {
            queryParameters['sort_order'] = requestParameters.sortOrder;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/prtimes_media_lists`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetMediaListsResponseFromJSON(jsonValue));
    }

    /**
     * メディアリスト一覧を取得するAPI
     * メディアリスト一覧を取得するAPI
     */
    async getPrtimesMediaLists(requestParameters: GetPrtimesMediaListsRequest = {}, initOverrides?: RequestInit): Promise<GetMediaListsResponse> {
        const response = await this.getPrtimesMediaListsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * メディアリストのメディアを取得するAPI
     * メディアリストのメディアを取得するAPI
     */
    async getPrtimesMediaListsMediaOutletsRaw(requestParameters: GetPrtimesMediaListsMediaOutletsOperationRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<GetPrtimesMediaListsMediaOutletsResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/prtimes_media_lists/media_outlets`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: GetPrtimesMediaListsMediaOutletsRequestToJSON(requestParameters.getPrtimesMediaListsMediaOutletsRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetPrtimesMediaListsMediaOutletsResponseFromJSON(jsonValue));
    }

    /**
     * メディアリストのメディアを取得するAPI
     * メディアリストのメディアを取得するAPI
     */
    async getPrtimesMediaListsMediaOutlets(requestParameters: GetPrtimesMediaListsMediaOutletsOperationRequest = {}, initOverrides?: RequestInit): Promise<GetPrtimesMediaListsMediaOutletsResponse> {
        const response = await this.getPrtimesMediaListsMediaOutletsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * PRTIMESリストの仮状態(DBに保存されていない状態)である、選択済みリストの履歴を取得するAPI
     * 選択済みリストの履歴を取得するAPI
     */
    async getSelectedMediaListLogRaw(requestParameters: GetSelectedMediaListLogRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<PrtimesMediaListsSelectedMediaListsLogGetResponse>> {
        if (requestParameters.mediaListId === null || requestParameters.mediaListId === undefined) {
            throw new runtime.RequiredError('mediaListId','Required parameter requestParameters.mediaListId was null or undefined when calling getSelectedMediaListLog.');
        }

        if (requestParameters.logId === null || requestParameters.logId === undefined) {
            throw new runtime.RequiredError('logId','Required parameter requestParameters.logId was null or undefined when calling getSelectedMediaListLog.');
        }

        const queryParameters: any = {};

        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }

        if (requestParameters.perPage !== undefined) {
            queryParameters['per_page'] = requestParameters.perPage;
        }

        if (requestParameters.dangerouslyFetchAllMediaOutlets !== undefined) {
            queryParameters['dangerously_fetch_all_media_outlets'] = requestParameters.dangerouslyFetchAllMediaOutlets;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/prtimes_media_lists/{media_list_id}/selected_media_lists/logs/{log_id}`.replace(`{${"media_list_id"}}`, encodeURIComponent(String(requestParameters.mediaListId))).replace(`{${"log_id"}}`, encodeURIComponent(String(requestParameters.logId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PrtimesMediaListsSelectedMediaListsLogGetResponseFromJSON(jsonValue));
    }

    /**
     * PRTIMESリストの仮状態(DBに保存されていない状態)である、選択済みリストの履歴を取得するAPI
     * 選択済みリストの履歴を取得するAPI
     */
    async getSelectedMediaListLog(requestParameters: GetSelectedMediaListLogRequest, initOverrides?: RequestInit): Promise<PrtimesMediaListsSelectedMediaListsLogGetResponse> {
        const response = await this.getSelectedMediaListLogRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 選択済みリストの履歴のメディア種別ごとのメディア数を取得するAPI
     * 選択済みリストの履歴のメディア種別ごとのメディア数を取得するAPI
     */
    async getSelectedMediaListLogMediaCountByTypeRaw(requestParameters: GetSelectedMediaListLogMediaCountByTypeRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<SelectedMediaListLogMediaCountByTypeGetResponse>> {
        if (requestParameters.mediaListId === null || requestParameters.mediaListId === undefined) {
            throw new runtime.RequiredError('mediaListId','Required parameter requestParameters.mediaListId was null or undefined when calling getSelectedMediaListLogMediaCountByType.');
        }

        if (requestParameters.logId === null || requestParameters.logId === undefined) {
            throw new runtime.RequiredError('logId','Required parameter requestParameters.logId was null or undefined when calling getSelectedMediaListLogMediaCountByType.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/prtimes_media_lists/{media_list_id}/selected_media_lists/logs/{log_id}/count_by_media_type`.replace(`{${"media_list_id"}}`, encodeURIComponent(String(requestParameters.mediaListId))).replace(`{${"log_id"}}`, encodeURIComponent(String(requestParameters.logId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SelectedMediaListLogMediaCountByTypeGetResponseFromJSON(jsonValue));
    }

    /**
     * 選択済みリストの履歴のメディア種別ごとのメディア数を取得するAPI
     * 選択済みリストの履歴のメディア種別ごとのメディア数を取得するAPI
     */
    async getSelectedMediaListLogMediaCountByType(requestParameters: GetSelectedMediaListLogMediaCountByTypeRequest, initOverrides?: RequestInit): Promise<SelectedMediaListLogMediaCountByTypeGetResponse> {
        const response = await this.getSelectedMediaListLogMediaCountByTypeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * PRTIMESリストの仮状態(DBに保存されていない状態)である、選択済みリストの履歴がある日付のリストを取得するAPI。 このAPIでアコーディオン表示するのに必要な情報のみ取得したいため、/prtimes_media_lists/{media_list_id}/selected_media_lists/logs/summaryとは別のAPIにしている。   * `400` - media_list_idが数値ではない時   * `400` - company_user_idが数値ではない時 
     * 選択済みリストの履歴がある日付のリストを取得するAPI
     */
    async getSelectedMediaListLogOnlyDatesRaw(requestParameters: GetSelectedMediaListLogOnlyDatesRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<PrtimesMediaListsSelectedMediaListsLogOnlyDatesGetResponse>> {
        if (requestParameters.mediaListId === null || requestParameters.mediaListId === undefined) {
            throw new runtime.RequiredError('mediaListId','Required parameter requestParameters.mediaListId was null or undefined when calling getSelectedMediaListLogOnlyDates.');
        }

        const queryParameters: any = {};

        if (requestParameters.companyUserId !== undefined) {
            queryParameters['company_user_id'] = requestParameters.companyUserId;
        }

        if (requestParameters.isDeletedCompanyUsersOnly !== undefined) {
            queryParameters['is_deleted_company_users_only'] = requestParameters.isDeletedCompanyUsersOnly;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/prtimes_media_lists/{media_list_id}/selected_media_lists/logs/only_dates`.replace(`{${"media_list_id"}}`, encodeURIComponent(String(requestParameters.mediaListId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PrtimesMediaListsSelectedMediaListsLogOnlyDatesGetResponseFromJSON(jsonValue));
    }

    /**
     * PRTIMESリストの仮状態(DBに保存されていない状態)である、選択済みリストの履歴がある日付のリストを取得するAPI。 このAPIでアコーディオン表示するのに必要な情報のみ取得したいため、/prtimes_media_lists/{media_list_id}/selected_media_lists/logs/summaryとは別のAPIにしている。   * `400` - media_list_idが数値ではない時   * `400` - company_user_idが数値ではない時 
     * 選択済みリストの履歴がある日付のリストを取得するAPI
     */
    async getSelectedMediaListLogOnlyDates(requestParameters: GetSelectedMediaListLogOnlyDatesRequest, initOverrides?: RequestInit): Promise<PrtimesMediaListsSelectedMediaListsLogOnlyDatesGetResponse> {
        const response = await this.getSelectedMediaListLogOnlyDatesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * PRTIMESリストの仮状態(DBに保存されていない状態)である、選択済みリストの履歴Summaryのリストを取得するAPI。   * `400` - media_list_idが数値ではない時   * `400` - dateの形式がYYYY-MM-DD HH:mm:ssではない時   * `400` - company_user_idが数値ではない時 
     * 選択済みリストの履歴Summaryのリストを取得するAPI
     */
    async getSelectedMediaListLogSummariesRaw(requestParameters: GetSelectedMediaListLogSummariesRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<PrtimesMediaListsSelectedMediaListsLogSummariesGetResponse>> {
        if (requestParameters.mediaListId === null || requestParameters.mediaListId === undefined) {
            throw new runtime.RequiredError('mediaListId','Required parameter requestParameters.mediaListId was null or undefined when calling getSelectedMediaListLogSummaries.');
        }

        if (requestParameters.date === null || requestParameters.date === undefined) {
            throw new runtime.RequiredError('date','Required parameter requestParameters.date was null or undefined when calling getSelectedMediaListLogSummaries.');
        }

        const queryParameters: any = {};

        if (requestParameters.date !== undefined) {
            queryParameters['date'] = requestParameters.date;
        }

        if (requestParameters.companyUserId !== undefined) {
            queryParameters['company_user_id'] = requestParameters.companyUserId;
        }

        if (requestParameters.isDeletedCompanyUsersOnly !== undefined) {
            queryParameters['is_deleted_company_users_only'] = requestParameters.isDeletedCompanyUsersOnly;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/prtimes_media_lists/{media_list_id}/selected_media_lists/logs/summaries`.replace(`{${"media_list_id"}}`, encodeURIComponent(String(requestParameters.mediaListId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PrtimesMediaListsSelectedMediaListsLogSummariesGetResponseFromJSON(jsonValue));
    }

    /**
     * PRTIMESリストの仮状態(DBに保存されていない状態)である、選択済みリストの履歴Summaryのリストを取得するAPI。   * `400` - media_list_idが数値ではない時   * `400` - dateの形式がYYYY-MM-DD HH:mm:ssではない時   * `400` - company_user_idが数値ではない時 
     * 選択済みリストの履歴Summaryのリストを取得するAPI
     */
    async getSelectedMediaListLogSummaries(requestParameters: GetSelectedMediaListLogSummariesRequest, initOverrides?: RequestInit): Promise<PrtimesMediaListsSelectedMediaListsLogSummariesGetResponse> {
        const response = await this.getSelectedMediaListLogSummariesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 指定されたメディアリストに含まれるメディアのIDリストを取得。結合対象が何百件となる可能性があるためリクエストボディを使いたいのでpostメソッドにしています（なので副作用はないです）。
     * 結合するメディアリストに含まれるユニークなメディアのIDリストを取得するAPI
     */
    async joinPrtimesMediaListsRaw(requestParameters: JoinPrtimesMediaListsRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<PrtimesMediaListsJoinResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/prtimes_media_lists/join`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PrtimesMediaListsJoinRequestToJSON(requestParameters.prtimesMediaListsJoinRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PrtimesMediaListsJoinResponseFromJSON(jsonValue));
    }

    /**
     * 指定されたメディアリストに含まれるメディアのIDリストを取得。結合対象が何百件となる可能性があるためリクエストボディを使いたいのでpostメソッドにしています（なので副作用はないです）。
     * 結合するメディアリストに含まれるユニークなメディアのIDリストを取得するAPI
     */
    async joinPrtimesMediaLists(requestParameters: JoinPrtimesMediaListsRequest = {}, initOverrides?: RequestInit): Promise<PrtimesMediaListsJoinResponse> {
        const response = await this.joinPrtimesMediaListsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * メディアリストに追加されているメディアを上書きするAPI
     * メディアリストに追加されているメディアを上書きするAPI
     */
    async overwritePrtimesMediaOutletsRaw(requestParameters: OverwritePrtimesMediaOutletsRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<MediaListApiResponse>> {
        if (requestParameters.mediaListId === null || requestParameters.mediaListId === undefined) {
            throw new runtime.RequiredError('mediaListId','Required parameter requestParameters.mediaListId was null or undefined when calling overwritePrtimesMediaOutlets.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/prtimes_media_lists/{media_list_id}/media_outlets`.replace(`{${"media_list_id"}}`, encodeURIComponent(String(requestParameters.mediaListId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: PrtimesMediaListMediaOutletsOverwriteRequestToJSON(requestParameters.prtimesMediaListMediaOutletsOverwriteRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MediaListApiResponseFromJSON(jsonValue));
    }

    /**
     * メディアリストに追加されているメディアを上書きするAPI
     * メディアリストに追加されているメディアを上書きするAPI
     */
    async overwritePrtimesMediaOutlets(requestParameters: OverwritePrtimesMediaOutletsRequest, initOverrides?: RequestInit): Promise<MediaListApiResponse> {
        const response = await this.overwritePrtimesMediaOutletsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * メディアリストの操作ログを記録するAPI
     * メディアリストの操作ログを記録するAPI
     */
    async recordPrtimesMediaListOperationLogRaw(requestParameters: RecordPrtimesMediaListOperationLogRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<MediaListApiResponse>> {
        if (requestParameters.mediaListId === null || requestParameters.mediaListId === undefined) {
            throw new runtime.RequiredError('mediaListId','Required parameter requestParameters.mediaListId was null or undefined when calling recordPrtimesMediaListOperationLog.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/prtimes_media_lists/{media_list_id}/log`.replace(`{${"media_list_id"}}`, encodeURIComponent(String(requestParameters.mediaListId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PrtimesMediaListOperationLogRecordRequestToJSON(requestParameters.prtimesMediaListOperationLogRecordRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MediaListApiResponseFromJSON(jsonValue));
    }

    /**
     * メディアリストの操作ログを記録するAPI
     * メディアリストの操作ログを記録するAPI
     */
    async recordPrtimesMediaListOperationLog(requestParameters: RecordPrtimesMediaListOperationLogRequest, initOverrides?: RequestInit): Promise<MediaListApiResponse> {
        const response = await this.recordPrtimesMediaListOperationLogRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * PRTIMESリストの仮状態(DBに保存されていない状態)である、選択済みリストの履歴を記録するAPI
     * 選択済みリストの履歴を記録するAPI
     */
    async recordSelectedMediaListLogRaw(requestParameters: RecordSelectedMediaListLogRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<PrtimesMediaListsSelectedMediaListsLogRecordResponse>> {
        if (requestParameters.mediaListId === null || requestParameters.mediaListId === undefined) {
            throw new runtime.RequiredError('mediaListId','Required parameter requestParameters.mediaListId was null or undefined when calling recordSelectedMediaListLog.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/prtimes_media_lists/{media_list_id}/selected_media_lists/logs`.replace(`{${"media_list_id"}}`, encodeURIComponent(String(requestParameters.mediaListId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PrtimesMediaListsSelectedMediaListsLogRecordRequestToJSON(requestParameters.prtimesMediaListsSelectedMediaListsLogRecordRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PrtimesMediaListsSelectedMediaListsLogRecordResponseFromJSON(jsonValue));
    }

    /**
     * PRTIMESリストの仮状態(DBに保存されていない状態)である、選択済みリストの履歴を記録するAPI
     * 選択済みリストの履歴を記録するAPI
     */
    async recordSelectedMediaListLog(requestParameters: RecordSelectedMediaListLogRequest, initOverrides?: RequestInit): Promise<PrtimesMediaListsSelectedMediaListsLogRecordResponse> {
        const response = await this.recordSelectedMediaListLogRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 論理削除されたメディアリストを復元するAPI
     * 論理削除されたメディアリストを復元するAPI
     */
    async restorePrtimesMediaListsRaw(requestParameters: RestorePrtimesMediaListsOperationRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<MediaListApiResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/prtimes_media_lists/restore`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RestorePrtimesMediaListsRequestToJSON(requestParameters.restorePrtimesMediaListsRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MediaListApiResponseFromJSON(jsonValue));
    }

    /**
     * 論理削除されたメディアリストを復元するAPI
     * 論理削除されたメディアリストを復元するAPI
     */
    async restorePrtimesMediaLists(requestParameters: RestorePrtimesMediaListsOperationRequest = {}, initOverrides?: RequestInit): Promise<MediaListApiResponse> {
        const response = await this.restorePrtimesMediaListsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * メディアを検索するAPI
     * メディアを検索するAPI
     */
    async searchMediaOutletsRaw(requestParameters: SearchMediaOutletsRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<PrtimesMediaListsMediaOutletsSearchResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/prtimes_media_lists/media_outlets/search`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PrtimesMediaListsMediaOutletsSearchRequestToJSON(requestParameters.prtimesMediaListsMediaOutletsSearchRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PrtimesMediaListsMediaOutletsSearchResponseFromJSON(jsonValue));
    }

    /**
     * メディアを検索するAPI
     * メディアを検索するAPI
     */
    async searchMediaOutlets(requestParameters: SearchMediaOutletsRequest = {}, initOverrides?: RequestInit): Promise<PrtimesMediaListsMediaOutletsSearchResponse> {
        const response = await this.searchMediaOutletsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 選択されているメディアを検索するAPI（検索キーワード、メディア種別、発行部数/PVから検索できる）
     * 選択されているメディアを検索するAPI（検索キーワード、メディア種別、発行部数/PVから検索できる）
     */
    async searchSelectedMediaOutletsRaw(requestParameters: SearchSelectedMediaOutletsOperationRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<SearchSelectedMediaOutletsResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/search_selected_prtimes_media_outlets`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SearchSelectedMediaOutletsRequestToJSON(requestParameters.searchSelectedMediaOutletsRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SearchSelectedMediaOutletsResponseFromJSON(jsonValue));
    }

    /**
     * 選択されているメディアを検索するAPI（検索キーワード、メディア種別、発行部数/PVから検索できる）
     * 選択されているメディアを検索するAPI（検索キーワード、メディア種別、発行部数/PVから検索できる）
     */
    async searchSelectedMediaOutlets(requestParameters: SearchSelectedMediaOutletsOperationRequest = {}, initOverrides?: RequestInit): Promise<SearchSelectedMediaOutletsResponse> {
        const response = await this.searchSelectedMediaOutletsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * メディアリストを更新するAPI
     * メディアリストを更新するAPI
     */
    async updatePrtimesMediaListRaw(requestParameters: UpdatePrtimesMediaListRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<UpdateMediaListResponse>> {
        if (requestParameters.mediaListId === null || requestParameters.mediaListId === undefined) {
            throw new runtime.RequiredError('mediaListId','Required parameter requestParameters.mediaListId was null or undefined when calling updatePrtimesMediaList.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/prtimes_media_lists/{media_list_id}`.replace(`{${"media_list_id"}}`, encodeURIComponent(String(requestParameters.mediaListId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateMediaListRequestToJSON(requestParameters.updateMediaListRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UpdateMediaListResponseFromJSON(jsonValue));
    }

    /**
     * メディアリストを更新するAPI
     * メディアリストを更新するAPI
     */
    async updatePrtimesMediaList(requestParameters: UpdatePrtimesMediaListRequest, initOverrides?: RequestInit): Promise<UpdateMediaListResponse> {
        const response = await this.updatePrtimesMediaListRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
    * @export
    * @enum {string}
    */
export enum GetPrtimesMediaListsSortFieldEnum {
    LastEditTime = 'last_edit_time',
    TotalCount = 'total_count'
}
/**
    * @export
    * @enum {string}
    */
export enum GetPrtimesMediaListsSortOrderEnum {
    Asc = 'asc',
    Desc = 'desc'
}
